import Badge from "../Badge";
import { convertToTitleCase, truncateText } from "../../Utils";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useTranslation } from "react-i18next";
import { LightningBoltIcon } from "@heroicons/react/solid";
import { useWebinarPricing } from "../../Hooks";
import { WebinarPricingInfo } from "../WebinarPricingInfo";

dayjs.extend(customParseFormat);

const WebinarCard = ({ webinar }) => {
  const { t, i18n } = useTranslation();
  const pricingInfo = useWebinarPricing(webinar);

  const isPastScheduledDate = new Date(webinar?.scheduledAt) < new Date();

  return (
    <div className="flex flex-col flex-auto gap-4">
      {webinar.imageUrl ? (
        <div className="relative rounded-md w-full h-auto aspect-video overflow-hidden">
          <img
            className="absolute object-contain w-full h-full z-10"
            src={webinar.imageUrl}
            alt="Webinar"
            loading="lazy"
          />
          <div
            className="absolute w-full h-full bg-fill blur-[50px] brightness-90 mask-gradient"
            style={{
              backgroundImage: `url('${webinar.imageUrl}')`,
            }}
          ></div>
        </div>
      ) : (
        <div className="rounded-md w-full h-auto aspect-video text-center overflow-hidden bg-gray-200 text-sm text-gray-500 flex flex-col justify-center">
          {t("No Image")}
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        {isPastScheduledDate ? (
          <Badge title="Finished" type="secondary" />
        ) : (
          <Badge
            {...(webinar.type === "PAID"
              ? { title: "webinars.webinarTypes.paid", type: "info" }
              : { title: convertToTitleCase(webinar?.type), type: "success" })}
          />
        )}
        {webinar.earnCertificate && (
          <Badge title="E-Certificate" type="alert" />
        )}
        {webinar?.easyRegistration && (
          <Badge
            icon={LightningBoltIcon}
            title="quickRegister"
            className="bg-purple-100 text-purple-800"
          />
        )}
        {Boolean(webinar?.documents) && webinar.documents.length > 0 && (
          <Badge title="Presentation Material" type="info" />
        )}
        {webinar?.recordingUrl && <Badge title="Recording" type="danger" />}
      </div>
      <div className="flex flex-col gap-1">
        <div>
          <h3 className="text-sm font-bold text-gray-900 text-left line-clamp-2">
            {webinar.title}
          </h3>
        </div>
        <div>
          <h3 className="text-sm font-normal text-gray-500 text-left line-clamp-3">
            {dayjs(webinar.scheduledAt)
              .locale(i18n.language)
              .format("DD MMM YYYY HH:mm")}
          </h3>
        </div>
        <div>
          <p className="text-sm text-gray-900 text-left line-clamp-3">
            {truncateText(webinar.body, 300)}
          </p>
        </div>
        {pricingInfo && (
          <WebinarPricingInfo
            pricingInfo={pricingInfo}
            showPricingTitle={false}
            containerClassName="mt-2 border rounded-md border-gray-300 p-3 bg-slate-50"
          />
        )}
      </div>
    </div>
  );
};

export default WebinarCard;
